import { useNavigate } from 'react-router-dom'
import { useUserContext } from '../../context/UserContext'
import SaddlefitLogo from '../../assets/icons/logo.svg?react'
import Button from '../../components/atoms/Buttons'

function NotFound() {
  const navigate = useNavigate()
  const { userData } = useUserContext()
  const isSignedIn = Boolean(localStorage.getItem('isSignedIn'))

  const isSimpleAdmin =
    userData?.brand !== 'saddlefitadmin' && (userData?.type === 'Admin' || userData?.type === 'Member')
  const fallbackRoute = isSimpleAdmin ? '/saddle-admin' : '/admin-dashboard'

  const handleGoHome = () => {
    navigate(fallbackRoute, { replace: true })
  }

  const handleGoBack = () => {
    navigate(-1)
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <div className="max-w-md w-full mx-auto text-center px-6">
        <div className="mb-8">
          <SaddlefitLogo />
        </div>

        <div className="mb-8">
          <h1 className="text-6xl font-bold text-gray-900 mb-4 font-barlowcondensed">
            404
          </h1>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4 font-barlowcondensed">
            Page Not Found
          </h2>
          <p className="text-gray-600 mb-8 font-montserrat">
            Sorry, we couldn't find the page you're looking for. The page might
            have been moved, deleted, or you might have entered the wrong URL.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {isSignedIn ? (
            <Button
              onClick={handleGoHome}
              primary
              className="px-6 py-3 font-montserrat text-white rounded-full cursor-pointer"
            >
              Go to Dashboard
            </Button>
          ) : (
            <Button
              onClick={handleGoBack}
              primary
              className="px-6 py-3 font-montserrat text-white rounded-full cursor-pointer"
            >
              Go Back
            </Button>
          )}
        </div>

        <div className="mt-8 text-sm text-gray-500">
          <p className="font-montserrat">
            If you believe this is an error, please contact support.
          </p>
        </div>
      </div>
    </div>
  )
}

export default NotFound
